enum VehicleStatus {
  gold = 1, // New
  volcano = 2, // Registered
  red = 3, // Rejected
  blue = 4, // Approved
  purple = 5, // InspectionDone
  magenta = 6, // PriceListed
  green = 7, // AuctionReady
  geekblue = 8, // Sold
  orange = 9, // Unsold
  lime = 10, // Withdrawn
  cyan = 11, // DeliveryReady
}

export default VehicleStatus;
